module.exports = "<a>{{::vm.cellValue}}</a>\n<span class='{{vm.validationClass}}'>\n\t{{::vm.validationValue}}\n</span>"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridValidationCell/tableGridValidationCell.html
// module id = 340
// module chunks = 1